export default __webpack_public_path__ + "static/media/arrow-down.6e49c584.svg";